<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Carteira gestor e vendedor"
      ></page-title>
      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anoSafra"
              label="Ano Safra"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Filial</label>
            <multiselect
              v-model="filter.branch"
              :options="branches"
              :select-label="''"
              :deselect-label="''"
              placeholder="Selecionar Filial"
              :selected-label="'Selecionado'"
              label="name"
              track-by="id"
            />
          </div>

          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Gestor</label>
            <multiselect
              v-model="filter.manager"
              :options="managers"
              :select-label="''"
              :deselect-label="''"
              placeholder="Selecionar Gestor"
              :selected-label="'Selecionado'"
              :loading="isLoadingManagers"
              :disabled="!currentUser.is_admin"
              label="name"
              track-by="id"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" @click="exportToExcel()">Gerar Excel</base-button>
          <base-button type="primary" class="ml-2 mt-2" @click="generateReport" v-loading="isLoading"
            >Gerar Relatório</base-button>
        </div>
      </card>
    </div>

    <card v-show="salesman.length" ref="report">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Vendedores - {{ lastEdition | formatDate("full") }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Vendedores - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anoSafra && Object.keys(filter.anoSafra).length"
        >
          Ano Safra: {{ filter.anoSafra.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.branch && Object.keys(filter.branch).length"
        >
          Filial: {{ filter.branch.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.manager && Object.keys(filter.manager).length"
        >
          Gestor: {{ filter.manager.name }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <el-table
        v-loading="isLoading"

        min-width="500px"

        :data="salesman"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        id="table01"
      >
        <el-table-column
          label="Nome"
          min-width="200px"
          prop="name"
          sortable
          class="hidden-th"
        />
        <el-table-column
          label="Filial"
          min-width="210px"
          prop="branch_name"
          sortable
          class="hidden-th"
        />
        <el-table-column
          label="Gestor"
          min-width="120px"
          prop="manager_name"
          sortable
          class="hidden-th"
        />
      </el-table>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

import { Table, TableColumn } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        anoSafra: {},
        branch: {},
        manager: {},
      },
      salesman: [],
      managers: [],
      branches: [],
      anoSafras: [],
      lastEdition: new Date(),
      isLoading: false,
      isLoadingManager: false
    };
  },
  methods: {
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    generateReport() {
      this.isLoading = true
      this.$http.secured
        .get("/api/v1/report/salesmans", {
          params: {
            "anosafras[id]": this.filter.anoSafra
              ? this.filter.anoSafra.id
              : null,
            "regions[branch_id]": this.filter.branch
              ? this.filter.branch.id
              : null,
            'anosafra_users[manager_id]': this.filter.manager ? this.filter.manager.id : null,
          },
        })
        .then((response) => {
          this.lastEdition = new Date();
          this.salesman = response.data;
          this.isLoading = false;
        });
    },
    initManagers(query) {
      this.isLoadingManagers = true;
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };

      if (this.filter.anoSafra && this.filter.anoSafra.id)
        data.q["anosafra_id"] = this.filter.anoSafra.id;

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.isLoadingManagers = false;
          this.managers = response.data.users || [];
        })
        .catch(() => (this.isLoadingManagers = false));
    },
    initBranches() {
      this.$http.secured
        .get("/api/v1/branches")
        .then((response) => (this.branches = response.data));
    },
    clearFilters() {
      this.filter.branch = {},
      this.filter.manager = {}
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    this.currentUser = this.$currentUser();
     if(this.$can('index', 'user')){
        this.initManagers('');
    }

    if (this.currentUser.is_admin) {
      this.initManagers('');
    } else if (this.currentUser.is_manager || this.currentUser.has_coordinateds) {
      this.filter.managers = [this.currentUser];
      this.filter.salesmans = this.currentUser.salesmans;
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.managers = [this.currentUser.manager];
      this.filter.salesmans = [this.currentUser];
      this.filter.manager = this.currentUser.manager;
      this.filter.salesman = this.currentUser;
    }
    this.initBranches();
  },
  watch: {
    'filter.anoSafra': function() {
       if(this.$can('index', 'user')){
        this.initManagers('');
      }
    }
  },
};
</script>
<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
</style>
